<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CedisTable
          :items="cedis"
          hover
          striped
          border
          small
          fixed
          caption="CEDIS"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CedisTable from '../../components/cedis/CedisTable.vue'
import ws from '../../services/cedis';
import store from '../../store'

export default {
  name: 'Cedis',
  components: { CedisTable },
  data: function () {
		return {
            cedis: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.cedis = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.cedis = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
